import type { ReactNode } from 'react';
import { RightOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

interface MobileWorkbenchCardProps {
  title: string;
  description?: string;
  to?: string;
  onClick?: () => void;
  icon?: ReactNode;
  accent?: boolean;
}

export function MobileWorkbenchCard({
  title,
  description,
  to,
  onClick,
  icon,
  accent,
}: MobileWorkbenchCardProps) {
  const content = (
    <>
      <div className="mobile-workbench-card__main">
        {icon ? <div className="mobile-workbench-card__icon">{icon}</div> : null}
        <div>
          <div className="mobile-workbench-card__title">{title}</div>
          {description ? <div className="mobile-workbench-card__desc">{description}</div> : null}
        </div>
      </div>
      <RightOutlined className="mobile-menu-item__arrow" />
    </>
  );

  if (to) {
    return (
      <Link
        className={`mobile-workbench-card${accent ? ' mobile-workbench-card--accent' : ''}`}
        to={to}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={`mobile-workbench-card${accent ? ' mobile-workbench-card--accent' : ''}`}
      onClick={onClick}
    >
      {content}
    </button>
  );
}

interface MobileStatItemProps {
  label: string;
  value: number;
  suffix?: string;
  tone?: 'default' | 'success' | 'warning';
}

export function MobileStatItem({ label, value, suffix = '', tone = 'default' }: MobileStatItemProps) {
  return (
    <div className={`mobile-stat-item mobile-stat-item--${tone}`}>
      <div className="mobile-stat-item__value">
        {value}
        {suffix}
      </div>
      <div className="mobile-stat-item__label">{label}</div>
    </div>
  );
}

export function MobileStatGrid({ children }: { children: ReactNode }) {
  return <div className="mobile-stat-grid">{children}</div>;
}
